import { render, staticRenderFns } from "./fileQuotaUsageChart.vue?vue&type=template&id=12072907&"
import script from "./fileQuotaUsageChart.vue?vue&type=script&lang=js&"
export * from "./fileQuotaUsageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports